window.addEventListener("DOMContentLoaded", () => {
  let articles = [];

  const fetchUrlParams = new URLSearchParams(window.location.search);
  fetchUrlParams.delete("page");
  fetchUrlParams.append("view", "ajax");
  const baseURL = window.location.href.split("?")[0];

  fetch(`${baseURL}?${fetchUrlParams.toString()}`)
    .then((response) => response.text())
    .then((htmlString) => {
      var parser = new DOMParser();
      var html = parser.parseFromString(htmlString, "text/html");
      const allArticlesContainer = html.querySelector(".blog-posts");
      articles = Array.from(
        allArticlesContainer.querySelectorAll(".blog-post-card")
      );

      const articlesContainer = document.querySelector(".blog-posts");

      const urlParams = new URLSearchParams(window.location.search);
      const pageNumber = urlParams.get("page") || 1;

      if (!urlParams.get("page")) {
        urlParams.append("page", 1);
        const newurl = `${baseURL}?${urlParams.toString()}`
        window.history.pushState({path:newurl},'', newurl);
      }

      const blog = document.querySelector(".blog");
      const pageLength = blog.getAttribute("data-pagination");

      setPagination(pageLength, pageNumber, articles, urlParams, baseURL);
      initialArticleSort(articlesContainer, articles, pageLength, pageNumber);

      const sortSelect = document.getElementById("sort-articles");
      sortSelect.addEventListener("change", (event) =>
        articleSort(event, articlesContainer, articles, pageLength, pageNumber)
      );
    });
});

function setPagination(pageLength, pageNumber, articles, urlParams, baseURL) {
  const paginationContainer = document.querySelector(".pagination");
  const currentPage = paginationContainer.querySelector(".current-page");
  const pageCountElement = paginationContainer.querySelector(".page-count");
  const pageCount = Math.ceil(articles.length / pageLength);
  const prevArrow = paginationContainer.querySelector('.pagination__item[rel="prev"]')
  const nextArrow = paginationContainer.querySelector('.pagination__item[rel="next"]')
  const prevArrowDisabled = paginationContainer.querySelector('.prev--disabled')
  const nextArrowDisabled = paginationContainer.querySelector('.next--disabled')


  urlParams.set("page", parseInt(pageNumber) - 1)
  const prevURLParmams = urlParams.toString()

  urlParams.set("page", parseInt(pageNumber) + 1)
  const nextURLParams = urlParams.toString()

  currentPage.innerText = pageNumber;
  pageCountElement.innerText = pageCount;

  prevArrowDisabled.style.display = 'none'
  nextArrowDisabled.style.display = 'none'

  if (parseInt(pageNumber) === 1) {
    prevArrow.style.display = 'none'
    prevArrowDisabled.style.display = 'block'

  } 
  if (parseInt(pageNumber) === pageCount) {
    nextArrow.style.display = 'none'
    nextArrowDisabled.style.display = 'block'
  }
  
  prevArrow.href = `${baseURL}?${prevURLParmams}`
  nextArrow.href = `${baseURL}?${nextURLParams}`
}

function initialArticleSort(
  articlesContainer,
  articles,
  pageLength,
  pageNumber
) {
  sortBy(articles, 'new-old')

  replaceArticles(articlesContainer, articles, pageNumber, pageLength)
}

function articleSort(
  event,
  articlesContainer,
  articles,
  pageLength,
  pageNumber
) {
  const sortMethod = event.target.value;
  sortBy(articles, sortMethod)

  replaceArticles(articlesContainer, articles, pageNumber, pageLength)
}

function replaceArticles(articlesContainer, articles, pageNumber, pageLength) {
  articlesContainer.innerHTML = "";

  const articlesToShow = articles.slice(
    (pageNumber - 1) * pageLength,
    pageNumber * pageLength
  );

  if (articlesToShow.length === 0) {
    articlesContainer.insertAdjacentHTML(
      "beforeend",
      '<div class="empty-articles>No Articles Found</div>'
    );
  } else {
    articlesToShow.forEach((article) => {
      articlesContainer.appendChild(article);
    });
  }
}

function sortBy(articles, sortMethod){
  if (sortMethod === "a-z") {
  articles.sort((a, b) => {
      const titleA = a.querySelector(".h3").innerText.toUpperCase();
      const titleB = b.querySelector(".h3").innerText.toUpperCase();
      return titleA.localeCompare(titleB);
    });
  }

  if (sortMethod === "new-old") {
    articles.sort((a, b) => {
      const dateA = a.getAttribute("data-date");
      const dateB = b.getAttribute("data-date");
      return dateA.localeCompare(dateB);
    });
  }
}